import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/posts';
import FaqAccordion from '@/components/feature/FaqAccordion';

export default function FaqPreviewSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-1.5 text-xs font-label tracking-[0.2em] text-primary-600 uppercase mb-3">
            <i className="ri-subtract-line" />
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 leading-tight">
            关于黑料看点，你可能想问
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-7">
            内容是否免费、更新频率、如何推荐名场面，这里都有直接的回答。如果还有疑问，欢迎留言告诉我们。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-foreground-900 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            查看全部问题
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="lg:col-span-8">
          <FaqAccordion items={faqs.slice(0, 4)} defaultOpen={0} />
        </div>
      </div>
    </section>
  );
}